
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import useAppState from '../../context/AppContext';
import * as Yup from 'yup';
import { ChangeEvent, useState } from 'react';
import MgpMessage from '../../elements/MgpMessage/MgpMessage';
import { IApiErrors,  } from '../../context/model';
import { getFilename, handleKeyDown, isAcceptedFileSizeMultiple, isValidFileSize, isValidFileType } from '../../utils/utils';
import UploadFilePreviewModal from '../../modals/common/UploadFilePreviewModal';
import { AxiosError } from 'axios';
import MgpInputFileUpload from '../../elements/MgpInputFileUpload/MgpInputFileUpload';
import ListOfFileUploaded from './ListOfFileUploaded';
import { ERROR_MESSAGES, PROPOSITION_DOC_TYPES } from '../../const/AppConst';
import Modal from 'react-modal';
import { compressFile } from '../../services/CustomerApiService';


type UploadTwoSidedMobileComponentProps = {
    isOpen: boolean,
    onCloseModal: () => void,
    onUploadAction: (fileToUpload: File, backSideFile: File) => void,
    docType: string,
    accessToken?: string,
    uploadError?: string
}

type AddStep0FormData = {
}

export default function UploadTwoSidedMobileComponent({isOpen, onCloseModal, onUploadAction, docType, accessToken, uploadError }: UploadTwoSidedMobileComponentProps) {

  Modal.setAppElement("#root");

  const {
    state: { jwtToken },
  } = useAppState();

  const [errorMsg, setErrorMsg] = useState<string | null>();
  const [errorFileTypeMsg, setErrorFileTypeMsg] = useState<boolean | null>();
  const [errorFileSizeMsg, setErrorFileSizeMsg] = useState<boolean | null>();
  const [file, setFile] = useState<File | null>(null);
  const [openPreviewFile, setOpenPreviewFile] = useState<boolean>(false);
  const [showUploadButton, setShowUploadButton] = useState<boolean>(false);
  const [rectoFile, setRectoFile ] = useState<File | null>(null);
  const [versoFile, setVersoFile ] = useState<File | null>(null);
  const [type, setType ] = useState<'RECTO' | 'VERSO'>('RECTO');


  const validationSchema = Yup.object().shape({
  });

  const {
    register,
    formState: { errors },
  } = useForm<AddStep0FormData>({
    mode: "onBlur",
    reValidateMode: "onChange",
    defaultValues: {

    },
    resolver: yupResolver(validationSchema),
  });


  const handleFileChange = async (event: ChangeEvent<HTMLInputElement>) => {
    try {
        const uploadedfile = event.target.files?.[0];
        if (uploadedfile) {
            if(!isValidFileType(uploadedfile)) {
                setErrorFileTypeMsg(true);
            } else if (!isValidFileSize(uploadedfile)) {
                setErrorFileSizeMsg(true);
            } else if(!isAcceptedFileSizeMultiple(uploadedfile)) {
              try {
                const token = accessToken ?? jwtToken!.accessToken;

                const res = await compressFile(token, uploadedfile);
                const content = res.data as Blob;
                const filename= type;
                const newFile = new File([content], filename, {type: uploadedfile.type});
                setOpenPreviewFile(true);
                setShowUploadButton(true);
                setFile(newFile);
                if (!rectoFile) {
                    setType('RECTO');
                } else {
                    setType('VERSO');
                }
              } catch(e) {
                setErrorMsg("Suite à un incident technique, nous ne pouvons pas uploader votre fichier. Veuillez sélectionner à nouveau.");
              } 
                
            } else {
                setOpenPreviewFile(true);
                setShowUploadButton(true);
                setFile(uploadedfile);
                if (!rectoFile) {
                    setType('RECTO');
                } else {
                    setType('VERSO');
                }
            }
        } else {
            setErrorMsg('Il y a une erreur sur votre téléchargement. Merci de réessayer');
        } 
    }  catch (error) {
        const err = error as AxiosError;
        console.log(err);
        if(err.response && err.response.status === 400) {
          const errorData = err.response?.data as IApiErrors;
          setErrorMsg("Erreur: " + errorData.message);
        } else {
          setErrorMsg("Une erreur technique est survenue ");
        }
    }
  };

  const onConfirmAction = () => { 
    setOpenPreviewFile(false);
    setErrorFileTypeMsg(false);
    setErrorFileSizeMsg(false);
    if (file) { 
        if (type === "RECTO") {
            setRectoFile(file);
        } else {
            setVersoFile(file);
        }
        setFile(null);
    }
  }

  const handleClosePreviewModal = () => {
    setOpenPreviewFile(false);
    setFile(null);
  }

  const onConfirmUploadAction = async () => {
    setErrorMsg(null);
    setErrorFileTypeMsg(false);

    try {
      if (rectoFile && versoFile) {
        onUploadAction(rectoFile, versoFile);
      } else {
        setErrorMsg("Une erreur technique est survenue. Veuillez recommencer un nouveau téléchargement.");
      }
 
    } catch (error) {
      const err = error as AxiosError;
      console.log(err);
      if(err.response && err.response.status === 400) {
        const errorData = err.response?.data as IApiErrors;
        setErrorMsg("Erreur: " + errorData.message);
      } else {
        setErrorMsg("Une erreur technique est survenue ");
      }
    }
  }

  const onDownLoadDocument = async (file: File) => {
      setFile(file);
      setOpenPreviewFile(true);
      setShowUploadButton(false);
  }

  const onReplaceDocument = async (event: ChangeEvent<HTMLInputElement>, doc: 'RECTO' | 'VERSO') => {
    const uploadedfile = event.target.files?.[0];
    if (uploadedfile) {
        if(!isValidFileType(uploadedfile)) {
            setErrorFileTypeMsg(true);
        } else if (!isValidFileSize(uploadedfile)) {
          setErrorFileSizeMsg(true);
        } else if(!isAcceptedFileSizeMultiple(uploadedfile)) {
          try {
            const token = accessToken ?? jwtToken!.accessToken;

            const res = await compressFile(token, uploadedfile);
            const content = new Blob([res.data], {type: res.headers['content-type']});
            const filename= getFilename(res.headers);
            const newFile = new File([content], filename);
            setOpenPreviewFile(true);
            setShowUploadButton(true);
            setFile(newFile);
            setType(doc);
          } catch(e) {
            setErrorMsg("Suite à un incident technique, nous ne pouvons pas uploader votre fichier. Veuillez sélectionner à nouveau.");
          } 
        } else {
            setOpenPreviewFile(true);
            setShowUploadButton(true);
            setFile(uploadedfile);
            setType(doc);
        }
    } else {
        setErrorMsg('Il y a une erreur sur votre téléchargement. Merci de réessayer');
    } 
  
  }

  const document = PROPOSITION_DOC_TYPES.find(el => el.code === docType);

  return (
    <Modal isOpen={isOpen} onRequestClose={onCloseModal}>
        <div className='modale open'>
            <div className="modale--content">
                <div className="modale--content--template">
                    <div className= "modale--main-width-entreprise shadow-bleu pb-lg bg-glace" >
                        <form className="p-x-lg p-y-lg">
                            <p className='card-title bleu'>{document?.label }</p>
                            <p className='text mb-md'>Veuillez télécharger le recto de votre document puis le verso. Ensuite, cliquez sur <strong>"Confirmer"</strong> pour les télécharger ou cliquez sur <strong>"Annuler"</strong> pour revenir à tout moment à la page principale. </p>

                            <div>
                                { errorFileTypeMsg && <MgpMessage type="danger" message={ERROR_MESSAGES.fileTypeMsg} hasCloseBtn={false}/> }
                                { errorFileSizeMsg && <MgpMessage type="danger" message={ERROR_MESSAGES.fileSizeMsg} hasCloseBtn={false}/> }
                                { uploadError && <p className="bg-fushia blanc p-md m-y-md">
                                    {uploadError.split('\n').map((line, index) => (
                                    <span key={index} style={{lineHeight: "18px"}}>
                                        {line}
                                    <br />
                                    </span>
                                    ))}
                                  </p>
                                }
                                { errorMsg && <MgpMessage type="danger" message={errorMsg} hasCloseBtn={true}/> }
                            </div> 

                            <div className="form-row">
                               
                                  { ((!rectoFile && type === "RECTO") || (!versoFile && type === "VERSO")) &&
                                  <div className="form-group mw-50">  
                                   <p className='fw-medium fz-lg mb-sm '>Veillez télécharger le {rectoFile ? 'verso' : 'recto'}</p>     
                                    <MgpInputFileUpload
                                        id="file"
                                        onChange={handleFileChange}
                                        register={register} 
                                        errors={errors}
                                        onClick={(e)=> e.currentTarget.value = ''}
                                        label={rectoFile ? 'VERSO' : 'RECTO'}
                                    />  
                                   </div>}
                               
                                
                                <div className='form-group mw-50'>                                  
                                    { (rectoFile && type === "RECTO" && !versoFile) &&
                                      <div className='m-y-xs bg-menthe-5 p-sm va-center ta-center'> 
                                        <p className='fw-medium fz-lg mb-sm '>Téléchargement le recto avec succès</p>
                                        <button className='cta-bleu' onClick={() => setType('VERSO')}>Continuer à télécharger le verso</button>
                                      </div> } 

                                    { versoFile && rectoFile && 
                                    <div>
                                      <p className='fw-medium fz-lg mb-sm '>Vos fichiers :</p>
                                    <div className='m-y-xs'> 
                                        <ListOfFileUploaded 
                                            fileName={`${document ? document.code : "document"}-recto`}
                                            onDownloadDocument={() => onDownLoadDocument(rectoFile)}
                                            onHandleFileChangeReplace={(e) => onReplaceDocument(e, 'RECTO')}
                                        />
                                      </div>
                                     <div className='m-y-xs'>  
                                        <ListOfFileUploaded 
                                            fileName={`${document ? document.code : "document"}-verso`}
                                            onDownloadDocument={() => onDownLoadDocument(versoFile)}
                                            onHandleFileChangeReplace={(e) => onReplaceDocument(e, 'VERSO')}
                                        /> 
                                    </div>
                                    </div> }            
                                </div>
                            </div>

                            <div className="mt-lg ta-center buttons-bloc">
                                <a className='cta-inline-bleu m-x-lg' onClick={onCloseModal} role='button' tabIndex={0} onKeyDown={(e) => handleKeyDown(e)}>Annuler</a>   
                                {rectoFile && versoFile && <a className='cta-bleu m-x-lg' onClick={onConfirmUploadAction} role='button' tabIndex={0} onKeyDown={(e) => handleKeyDown(e)}>Confirmer</a> }
                            </div>    
                        </form>

                        { openPreviewFile && file && <UploadFilePreviewModal file={file as File} onUploadAction={onConfirmAction} isOpen={openPreviewFile} onCloseModal={handleClosePreviewModal} showButton={showUploadButton}/>}   
                    </div>
                </div>
            </div>
        </div>
    </Modal>
  
  )
}
